/*!

=========================================================
*　支店詳細
=========================================================
*/
import React from "react";
import { Link } from 'react-router-dom';
import {
  Button,
  Card,  CardHeader,  CardBody,  CardTitle,
  Table,  Row,  Col,
} from "reactstrap";

import Request from '../../common/Request';
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip'
import SystemInfo from '../ViewParts/SystemInfo';
import CustomTd from '../ViewParts/CustomTd';
import Definition from '../../common/Definition';
import WithRole from '../FormParts/ButtonWithRole';
import OpenFaxModal from '../FormParts/OpenFaxModal'
import FormatCode from "../../common/FormatCode";
import ApprovedInfo from '../ViewParts/ApprovedInfo';

const domain = "";

class BranchDetail extends React.Component {

  constructor(props){
    super(props);
    this.state ={
      customer_id: "",
      data: {
        values:{},
      },
      customer: [],
      user_data: [],
      pagetitle: "支店情報詳細"
    };

    this.search = this.search.bind(this);
    
  } 

  // 検索
  search() {
    /* ここは開発者が記述 */
    var url = domain + '/api/customer/branch/' + this.props.match.params.customer_branch_id;
    let params = {}
    Request.get(url,params,res => {

      this.setState({
        data:{
          values:res.Data
        },
        customer:res.Data
      });

      var url = domain + '/api/customer/user';
      Request.get(url,{
        customer_branch_ulid: res.Data.ulid
      },res => {
        this.setState({
          user_data:res.Data
        });     
      })
      var url = domain + '/api/landmark/lastupdate/' + res.Data.lastupdate_user_id;
      var params = {};
      Request.get(url, params, res => {
        let tmp = this.state.data.values;
        tmp.lastupdate_user = res.Data;
        this.setState({data:{values:tmp}});
      });      
    });


  }

  // 初期ロード用
  UNSAFE_componentWillMount(){
    //var query = queryString.parse(this.props.location.search);
    /*　ここは開発者が記述　*/
    this.search();
    // スクロールバーを表示するように設定
    document.body.style.overflow = "auto";
  }
  
  render() {
    const ButtonWithTooltipWithRole = WithRole(ButtonWithTooltip, this.props.buttons)
    const {
      invoice_bank_name,
      invoice_bank_branch_name,
      invoice_bank_account_kana,
      invoice_bank_account_type,
      invoice_bank_account_number
    } = this.state.data.values;
    const invoice_bank = `${invoice_bank_name}　${invoice_bank_branch_name || ""}　${FormatCode.decode("cst_payment_bank_account_type", invoice_bank_account_type)}　${invoice_bank_account_number || ""}　${invoice_bank_account_kana || ""}`
    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h3" className="float-left">{this.state.pagetitle}</CardTitle>
                  <ButtonWithTooltipWithRole
                    button_id="BTN_M1_06_04020"
                    onclick={() => { this.props.history.push("/customer/update/branch/"+this.props.match.params.customer_branch_id) }}
                    class="float-right btn-facebook"
                    id="tmp"
                    icon="fas fa-pen"
                    link=""
                    label="編集"
                    message={this.props.match.params.customer_branch_id+"を編集"}
                    />                   
                </CardHeader>
                <CardBody>
                <Row>
                  <Col md="11" className="detail">
                    <Card>
                    <ApprovedInfo
                    visible={this.state.view}
                    rootData={this.state.data}
                    />    
                    <SystemInfo
                        id_title='支店ID'
                        id_value={this.state.data.values.customer_branch_natural_id}
                        update_timestamp={this.state.data.values.update_timestamp}
                        update_user={this.state.data.values.lastupdate_user && this.state.data.values.lastupdate_user.name}
                        update_user_picture={this.state.data.values.lastupdate_user && this.state.data.values.lastupdate_user.picture}
                        visible={this.state.view}
                        />    
                      <CardTitle tag="h4">管理情報</CardTitle>
                      <Table>
                        <tbody>
                          <tr>
                              <td className="subTitle">ランドマーク担当者</td>
                              <td colSpan="3" className="text-left">
                                  {this.state.data.values.responsible_user_name && this.state.data.values.responsible_user_name != "" && (<>
                                  <div className="photo">
                                    {this.state.data.values.responsible_user_picture && <img alt="..." src={this.state.data.values.responsible_user_picture} />}
                                  </div>
                                  {this.state.data.values.responsible_user_name}
                                  </>)}
                              </td>
                          </tr>
                          <tr>
                            <CustomTd label='メモ'
                              name='CUSTOMER_BRANCH__system_memo'
                              copy={false}
                              data={this.state.data.values}
                            />
                          </tr>
                          <tr>
                            <CustomTd label='削除フラグ'
                              name='CUSTOMER_BRANCH__delete_flag'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                          <tr>
                            <CustomTd label='自動承認フラグ'
                              name='CUSTOMER_BRANCH__auto_approval_flag'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                        </tbody>
                      </Table>                         

                      <CardTitle tag="h4" className="float-left">基本情報</CardTitle>
                      <Table>
                        <tbody>
                        <tr>
                            {/* <th rowSpan="2">会社情報</th> */}
                            <CustomTd label='会社名'
                              name='CUSTOMER__customer_name'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>                       
                          <tr>
                            <CustomTd label='会社名（カナ）'
                              name='CUSTOMER__customer_name_kana'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>                       
                          <tr>
                            {/* <th rowSpan="4">支店情報</th> */}
                            <CustomTd label='支店名'
                              name='CUSTOMER_BRANCH__customer_branch_name'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>                       
                          <tr>
                            <CustomTd label='支店名称無フラグ'
                              name='CUSTOMER_BRANCH__customer_branch_noname_flag'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                          <tr>
                            <CustomTd label='支店名（カナ）'
                              name='CUSTOMER_BRANCH__customer_branch_name_kana'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>                       
                          <tr>
                            <CustomTd label='電話番号'
                              name='CUSTOMER_BRANCH__customer_branch_tel'
                              copy={true}
                              data={this.state.data.values} />
                          </tr>                       
                          <tr>
                            <CustomTd label='FAX番号'
                              name='CUSTOMER_BRANCH__customer_branch_fax'
                              value={
                                <OpenFaxModal
                                  data={this.state.data.values}
                                  onClick={()=>this.props.faxModal.current.setFaxModal({
                                    fax_recipient_name:this.state.data.values.customer_name
                                      +"\n"+this.state.data.values.customer_branch_name+" 御中",
                                    fax_recipient_number:this.state.data.values.customer_branch_fax
                                  })}
                                />
                              }
                            />
                          </tr>                       

                          <tr>
                            {/* <th rowSpan="4">所在地</th> */}
                            <CustomTd label='郵便番号'
                              name='CUSTOMER_BRANCH__customer_branch_zip_code'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                          <tr>
                            <CustomTd label='都道府県'
                              name='CUSTOMER_BRANCH__customer_branch_prefecture'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>                       
                          <tr>
                            <CustomTd label='市区町村'
                              name='CUSTOMER_BRANCH__customer_branch_city'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>                       
                          <tr>
                            <CustomTd label='番地（町名以降）'
                              name='CUSTOMER_BRANCH__customer_branch_address'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>                       
                          <tr>
                            <CustomTd label='調査見積時のCCメールアドレス'
                              name='CUSTOMER_BRANCH__customer_branch_cc_email'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                          <tr>
                            <CustomTd label='確定見積時のCCメールアドレス'
                              name='CUSTOMER_BRANCH__customer_branch_cc_email_quote'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                          <tr>
                            <CustomTd label='リマインド送信有無'
                              name='CUSTOMER_BRANCH__customer_branch_reminder_send_flag'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                          <tr>
                            <CustomTd label='請求担当デフォルト設定'
                              name='CUSTOMER_BRANCH__invoice_customer_user_setting'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                          <tr>
                            {/* <th>請求担当</th> */}
                            <CustomTd label='請求担当'
                              name='CUSTOMER_BRANCH__invoice_customer_user_name'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                          <tr>
                            <CustomTd label='請求書送付先住所：郵便番号'
                              name='CUSTOMER_BRANCH__customer_branch_invoice_zip_code'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                          <tr>
                            <CustomTd label='請求書送付先住所：都道府県'
                              name='CUSTOMER_BRANCH__customer_branch_invoice_prefecture'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                          <tr>
                            <CustomTd label='請求書送付先住所：市区町村'
                              name='CUSTOMER_BRANCH__customer_branch_invoice_city'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                          <tr>
                            <CustomTd label='請求書送付先住所：番地（町名以降）'
                              name='CUSTOMER_BRANCH__customer_branch_invoice_address'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                          <tr>
                            <CustomTd label='請求情報：振込口座'
                              name='CUSTOMER_BRANCH__invoice_bank_name'
                              copy={false}
                              value={invoice_bank}
                              />
                          </tr>
                          <tr>
                            <CustomTd label='自動発注機能'
                              name='CUSTOMER_BRANCH__auto_order_display_flag'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                        </tbody>
                      </Table>
                      <CardTitle tag="h4" className="float-left">クライアントルール</CardTitle>
                      <Table>
                        <tbody>
                            {/* <th rowSpan="8">見積ルール</th> */}                       
                          <tr>
                            <CustomTd label='上乗せ額'
                              name='CUSTOMER_BRANCH__additional_amt'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>                       
                          <tr>
                            <CustomTd label='上乗せ額の上限'
                              name='CUSTOMER_BRANCH__upper_limit_additional_amt'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                          <tr>
                            <CustomTd label='手数料割引率（％）'
                              name='CUSTOMER_BRANCH__discount_rate'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>                       
                          <tr>
                            <CustomTd label='値引'
                              name='CUSTOMER_BRANCH__discount_amt'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>                       
                          <tr>
                            <CustomTd label='税込フラグ'
                              name='CUSTOMER_BRANCH__tax_in_flag'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>                       
                          <tr>
                            <CustomTd label='端数調整'
                              name='CUSTOMER_BRANCH__fraction_amt_flag'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                          <tr>
                            <CustomTd label='締日ルール'
                              name='CUSTOMER_BRANCH__due_day_rule'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                          <tr>
                            <CustomTd label='締日日付'
                              name='CUSTOMER_BRANCH__due_day_rule_day'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                          <tr>
                            <CustomTd label='支払期限日ルール：月'
                              name='CUSTOMER_BRANCH__payment_due_rule_month'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                          <tr>
                            <CustomTd label='支払期限日ルール：日'
                              name='CUSTOMER_BRANCH__payment_due_rule_day'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                          <tr>
                            <CustomTd label='基本契約締結日（業務委託基本契約書）'
                              name='CUSTOMER_BRANCH__basic_contract_signing_date'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                          <tr>
                            <CustomTd label='請求書作成：有無'
                              name='CUSTOMER_BRANCH__invoice_create_flag'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                          <tr>
                            <CustomTd label='一覧請求書作成：有無'
                              name='CUSTOMER_BRANCH__invoice_list_create_flag'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                          {/* 2021-11-26 feature/1041 */}
                          <tr>
                            <CustomTd label='一覧請求書作成：作成区分'
                              name='CUSTOMER_BRANCH__invoice_list_create_type'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                          <tr>
                            <CustomTd label='契約書作成：有無'
                              name='CUSTOMER_BRANCH__contract_create_flag'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                          <tr>
                            <CustomTd label='請求関係メモ'
                              name='CUSTOMER_BRANCH__invoice_memo'
                              copy={false}
                              data={this.state.data.values} />
                          </tr>
                          <tr>
                            <CustomTd label='独自見積書フォーマットURL'
                              name='CUSTOMER_BRANCH__estimate_format_url'
                              copy={false}
                              rootData={this.state.data}
                              value={this.state.data.values.estimate_format_url&&
                                <a target="_blank" href={"https://docs.google.com/spreadsheets/d/"+this.state.data.values.estimate_format_url}>
                                  独自見積書フォーマット確認
                                </a>
                              }
                            />
                          </tr>
                          <tr>
                            <CustomTd label='独自請求書フォーマットURL'
                              name='CUSTOMER_BRANCH__invoice_format_url'
                              copy={false}
                              rootData={this.state.data}
                              value={this.state.data.values.invoice_format_url&&
                                <a target="_blank" href={"https://docs.google.com/spreadsheets/d/"+this.state.data.values.invoice_format_url}>
                                  独自請求書フォーマット確認
                                </a>
                              }
                            />
                          </tr>
                          <tr>
                            <CustomTd label='独自一覧請求書フォーマットURL'
                              name='CUSTOMER_BRANCH__invoice_list_format_url'
                              copy={false}
                              rootData={this.state.data}
                              value={this.state.data.values.invoice_list_format_url&&
                                <a target="_blank" href={"https://docs.google.com/spreadsheets/d/"+this.state.data.values.invoice_list_format_url}>
                                  独自一覧請求書フォーマット確認
                                </a>
                              }
                            />
                          </tr> 
                          <tr>
                            <CustomTd label='独自契約書フォーマットURL'
                              name='CUSTOMER_BRANCH__contract_format_url'
                              copy={false}
                              rootData={this.state.data}
                              value={this.state.data.values.contract_format_url&&
                                <a target="_blank" href={"https://docs.google.com/spreadsheets/d/"+this.state.data.values.contract_format_url}>
                                  独自契約書フォーマット確認
                                </a>
                              }
                            />
                          </tr>
                        </tbody>
                      </Table>
                      {this.state.data.values.c_customer_system_use_flag==1&&<CardTitle tag="h4" className="float-left">顧客向けシステム利用情報</CardTitle>}
                      <Table>
                        <tbody>
                          {this.state.data.values.c_customer_system_use_flag==1&&
                            <tr>
                              <CustomTd label='顧客向け利用有無'
                                name='CUSTOMER_BRANCH__customer_system_use_flag'
                                copy={false}
                                colSpan="8"
                                value={FormatCode.decode("cst_customer_system_use_flag",this.state.data.values.customer_system_use_flag)}
                              />
                            </tr>
                          }
                          {this.state.data.values.c_customer_system_use_flag==1&&this.state.data.values.customer_system_use_flag==1&&<>
                            <tr>
                              <CustomTd label='顧客システム利用開始日'
                                  name='CUSTOMER_BRANCH__customer_system_start_date'
                                  copy={false}
                                  colSpan="8"
                                  data={this.state.data.values}
                                />
                            </tr>
                            <tr>
                              <CustomTd label='顧客システム利用終了日'
                                  name='CUSTOMER_BRANCH__customer_system_end_date'
                                  copy={false}
                                  colSpan="8"
                                  data={this.state.data.values}
                              />
                            </tr>
                            <tr>
                              <CustomTd label='道路使用許可利用有無'
                                  name='CUSTOMER_BRANCH__road_usage_permission_use_flag'
                                  copy={false}
                                  colSpan="8"
                                  data={this.state.data.values}
                              />
                            </tr>
                            <tr>
                              <CustomTd label='承認機能利用'
                                  name='CU_CUSTOMER_OPTION__approval'
                                  copy={false}
                                  colSpan="4"
                                  data={this.state.data.values}
                              />
                              {this.state.data.values.approval==1&&
                                <CustomTd label='承認の段階'
                                    name='CU_CUSTOMER_OPTION__approval_step'
                                    copy={false}
                                    colSpan="4"
                                    data={this.state.data.values}
                                />
                              }
                            </tr>
                            <tr>
                              <CustomTd label='会社ログインID'
                                  name='CU_CUSTOMER_OPTION__customer_login_id'
                                  copy={false}
                                  colSpan="8"
                                  value={this.state.data.values.customer_login_id}
                                />
                            </tr>
                            <tr>
                              <CustomTd label='システム管理者'
                                name='CU_CUSTOMER_OPTION__admin_user_login_id'
                                copy={false}
                                colSpan="8"
                                data={this.state.data.values}
                              />
                            </tr>
                            <tr>
                              <CustomTd label='ダンドリワーク連携'
                                  name='CUSTOMER_BRANCH__dandori_work_use_flag'
                                  copy={false}
                                  colSpan="8"
                                  data={this.state.data.values}
                              />
                            </tr>
                            { this.state.data.values.dandori_work_use_flag != 0 &&
                            <>
                            <tr>
                              <CustomTd label='（ダンドリワーク連携）プレイスコード'
                                  name='CUSTOMER_BRANCH__dandori_work_place_code'
                                  copy={false}
                                  colSpan="8"
                                  data={this.state.data.values}
                              />
                            </tr>
                            <tr>
                              <CustomTd label='（ダンドリワーク連携）アクセストークン'
                                  name='CUSTOMER_BRANCH__dandori_work_access_token'
                                  copy={false}
                                  colSpan="8"
                                  data={this.state.data.values}
                              />
                            </tr>
                            <tr>
                              <CustomTd label='（ダンドリワーク連携）オリジナル項目　項目番号'
                                  name='CUSTOMER_BRANCH__dandori_work_original_item_number'
                                  copy={false}
                                  colSpan="8"
                                  data={this.state.data.values}
                              />
                            </tr>
                            </>
                            }
                            <tr>
                            <CustomTd label='現場plus連携'
                              name='CUSTOMER_BRANCH__ex_genba_plus_use_flag'
                              copy={false}
                              colSpan="8"
                              data={this.state.data.values}
                            />
                            </tr>
                            { this.state.data.values.ex_genba_plus_use_flag != 0 &&
                              <tr>
                                <CustomTd label='（現場plus連携）APIルートURL'
                                  name='CUSTOMER_BRANCH__ex_genba_plus_api_root_url'
                                  copy={false}
                                  colSpan="8"
                                  data={this.state.data.values}
                                />
                              </tr>
                            }
                            <tr>
                            <CustomTd label='ANDPAD連携'
                              name='CUSTOMER_BRANCH__ex_andpad_use_flag'
                              copy={false}
                              colSpan="8"
                              data={this.state.data.values}
                            />
                            </tr>
                            { this.state.data.values.ex_andpad_use_flag != 0 &&
                              <>
                                <tr>
                                  <CustomTd label='(ANDPAD)APIアクセストークン'
                                    name='CUSTOMER_BRANCH__ex_andpad_access_token_key'
                                    copy={false}
                                    colSpan="8"
                                    data={this.state.data.values}
                                  />
                                </tr>
                                <tr>
                                  <CustomTd label='確定見積書連携の有無'
                                    name='CUSTOMER_BRANCH__ex_andpad_quote_file_flag'
                                    copy={false}
                                    colSpan="8"
                                    data={this.state.data.values}
                                  />
                                </tr>
                              </>
                            }
                          </>}
                        </tbody>
                      </Table>
                      <CardTitle tag="h4" className="float-left">担当者一覧</CardTitle>
                      <Col md="11">
                        <Card>
                          <CardBody className="sub detail_sub">
                          <Table className="card-border">
                            <thead>
                              <tr>
                                <th>担当者名</th>
                                <th>担当者連絡先</th>
                                <th>
                                <ButtonWithTooltipWithRole
                                  button_id="BTN_M1_06_04030"
                                  disabled={this.state.data.values.customer_delete_flag === 1 || this.state.data.values.delete_flag === 1}
                                  onclick=""
                                  class="float-right btn-facebook"
                                  id="tmp"
                                  icon="fas fa-plus"
                                  link={"/customer/add/user/"+this.props.match.params.customer_branch_id}
                                  target="_blank"
                                  label="追加"
                                  message="担当を追加"
                                  size="sm"
                                  />                                    
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                            {this.state.user_data.map((prop,key) => {
                              return (
                                <>
                                <tr className="table-link">
                                    <td>
                                      <Link target="_blank" to={"/customer/detail/user/"+prop.ulid}>{prop.customer_user_name}</Link></td>
                                    <td colSpan="2"><div className='line-break' dangerouslySetInnerHTML={{__html:Definition.item('__JOIN_customer_user_contact_information', prop)}} /></td>
                                </tr>
                                </>
                              );
                            })}

                            </tbody>
                          </Table>
                          <Button onClick={() => { this.props.history.push('/customer?customer_natural_id='+this.state.data.values.customer_natural_id+'&customer_branch_natural_id='+this.state.data.values.customer_branch_natural_id) }} className="float-left">一覧に戻る</Button>
                        </CardBody>
                      </Card>
                      </Col>
                    </Card>
                  </Col>
                </Row>
                </CardBody>
              </Card>
            </Col>            
          </Row>
        </div>
      </>
    );
  }
}

export default BranchDetail;
